<template>
  <!-- 科普上传  -->
  <div class="Materialtoupload">
    <div class="box">
      <div class="tbox-top">
        <!-- <h4 class="scsc">我的上传</h4> -->
        <div style="display: flex; align-items: center; height: 20px">
          <span style="font-size: 13px; color: #333; font-weight: 500"
            >筛选 ：</span
          >
          <el-select
            @change="selmaterialis()"
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- <div class="ssssc" @click="Alltheupload()">全部上传</div>
        <div class="deleta" @click="delmatess()">全部删除</div> -->
      </div>
      <ul>
        <li
          :class="[
            item.status === '已保存' || item.status === '已驳回'
              ? 'wzts'
              : 'scscxsk',
          ]"
          v-for="item in formInline"
          :key="item.id"
        >
          <video
            @click="item.status === '已通过' ? jump(item) : null"
            v-if="item.sorts === '视频'"
            :src="http + item.video"
            controls
          ></video>
          <img
            v-else
            @click="item.status === '已通过' ? jump(item) : null"
            :src="item.picture ? item.picture : commonImg"
            alt=""
          />
          <el-form :inline="true" ref="formInline" class="demo-form-s">
            <el-form-item label="科普标题" size="mini">
              <el-input
                style="width: 300px"
                :disabled="item.tid !== null"
                v-model="item.name"
                placeholder="审批人"
              ></el-input>
            </el-form-item>

            <el-form-item label="科普分类" size="mini">
              <el-select
                :disabled="item.tid !== null"
                style="width: 300px"
                v-model="item.sort"
                placeholder="请选择类别"
              >
                <el-option
                  v-for="item in Majorcategories"
                  :key="item.id"
                  :label="item.sort"
                  :value="item.sort"
                ></el-option>
              </el-select>
            </el-form-item>

            <div class="smis">
              <span v-if="item.status === '已通过'"
                >通过时间：{{ item.knowdate }}</span
              >
              <span v-if="item.status === '已保存'"
                >保存时间：{{ item.knowdate }}</span
              >
              <span v-if="item.status === '待审核'"
                >文件上传时间：{{ item.knowdate }}</span
              >
              <span v-if="item.status === '已驳回'"
                >驳回时间：{{ item.knowdate }}</span
              >
            </div>
          </el-form>
          <div class="right-bottom">
            <span
              v-if="item.status === '已通过'"
              class="sadda saddsa"
              @click="jump(item)"
            >
              {{ item.status }}(查看)</span
            >
            <span v-if="item.status === '已保存'" class="sadda saddsa2">
              {{ item.status }}</span
            >
            <span v-if="item.status === '待审核'" class="sadda saddsa1">
              {{ item.status }}</span
            >
            <span
              v-if="item.status === '已驳回'"
              class="sadda saddsa3"
              @click="dialogVisiblebhss(item)"
            >
              已驳回(查看)
            </span>
            <!-- <span
              v-if="item.status === '已撤回'"
              class="sadda saddsa3"
              @click="(chehuiyuassnyin = true), (textarssea = item.bhyy)"
            >
              已撤回(查看)
            </span> -->

            <el-button
              v-show="item.status === '已保存' || item.status === '已驳回'"
              class="sch"
              style="margin: 10% 0"
              type="danger"
              @click="delmaterial(item)"
              >删除</el-button
            >
            <!-- <el-button
              v-show="item.status === '已通过'"
              class="sch"
              style="margin: 10% 0"
              type="danger"
              @click="chehuisyuanyin(item)"
              >撤回</el-button
            > -->
            <el-button
              class="lasez"
              v-if="
                item.status === '已保存' ||
                item.status === '已撤回' ||
                item.status === '已驳回'
              "
              type="primary"
              @click="$router.push(`/KPdetails/${item.id}`)"
              >详细信息</el-button
            >
            <!-- <el-button
              class="lasez"
              v-if="item.status === '驳回'"
              type="primary"
              @click="sssubmitForm(item)"
              >保存</el-button
            > -->
            <el-button
              v-if="
                item.status === '已保存' ||
                item.status === '已驳回' ||
                item.status === '已撤回'
              "
              class="lasez"
              style="margin: 10% 0"
              type="primary"
              @click="Fileupload(item)"
              >提交科普</el-button
            >
          </div>
        </li>
      </ul>

      <el-dialog
        title="驳回原因"
        :visible.sync="dialogVisiblebh"
        width="50%"
        :before-close="handleClose"
      >
        <p>{{ bhyys }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="撤回原因" :visible.sync="chehuiyuassnyin" width="50%">
        <span>{{ textarssea }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="chehuiyuassnyin = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="撤回原因" :visible.sync="chehuiyuanyin" width="50%">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarssea"
        >
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="chehuiyuanyin = false">取 消</el-button>
          <el-button type="primary" @click="chehuizhua()">确 定</el-button>
        </span>
      </el-dialog>

      <el-pagination
        class="paging"
        background
        prev-text="上一页"
        next-text="下一页"
        @current-change="handleCurrentChangess"
        :page-size="tepage.rows"
        layout="prev, pager, next"
        :total="tepage.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  selsortMu,
  delknow,
  updmaterialsp,
  updmaterial,
  selknow,
  updknow,
  updatetaskuser,
} from "../../../api/patient";
export default {
  data() {
    return {
      wdscxx: "课程上传",
      chehuiyuassnyin: false,
      chehuiyuanyin: false,
      chehid: "",
      http: this.$store.state.https,
      commonImg: require("../../../assets/common/jkkp.png"),
      name: "",
      tepage: {
        page: 1,
        rows: 9,
        total: 100,
      },
      Majorcategories: "",
      value: "全部",
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "已保存",
          label: "已保存",
        },
        {
          value: "待审核",
          label: "待审核",
        },
        {
          value: "已通过",
          label: "已通过",
        },
        {
          value: "已驳回",
          label: "已驳回",
        },
      ],
      formInline: [],
      rules: {},
      dialogVisiblebh: false,
      bhyys: "",
      textarssea: "",
    };
  },
  created() {
    // if (this.$store.state.ybcs !== 1) { this.value = this.$store.state.ybcs }
    this.selmaterialis();
    this.selsortis();
  },
  methods: {
    // 导航栏切换
    handleSelect(val) {
      this.$store.commit("wdsc", val);
      this.wdscxx = this.$store.state.wdsc;
    },
    chehuisyuanyin(item) {
      this.chehuiyuanyin = true;
      this.chehid = item.id;
    },
    chehuizhua() {
      if (this.textarssea !== "" && this.textarssea !== null) {
        var datas = new FormData();
        datas.append("ids", this.chehid);
        datas.append("status", "已撤回");
        datas.append("bhyy", this.textarssea);
        updmaterialsp(datas).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.chehuiyuanyin = false;
            this.selmaterialis();
          }
        });
      } else {
        this.$message({
          message: "请填写完整",
          type: "warning",
        });
      }
    },
    uploadmaterial() {
      if (this.$store.state.isLogin) {
        this.$router.push("/Uploadpagem");
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    handleClose() {
      this.dialogVisiblebh = false;
      this.bhyys = "";
    },
    smdpsoap(item) {
      this.chehuiyuanyin = true;
      this.textarssea = item.bhyy;
    },
    dialogVisiblebhss(item) {
      this.dialogVisiblebh = true;
      this.bhyys = item.cause;
    },
    // 上传全部
    async Alltheupload() {
      var isss = 0;
      const set = []; // set 自带去重
      for (let s = 0; s < this.formInline.length; s++) {
        if (this.formInline[s].status === "已保存") {
          var datas = new FormData();
          datas.append("id", this.formInline[s].id);
          datas.append("scwj", this.formInline[s].scwj);
          datas.append("scmc", this.formInline[s].scmc);
          datas.append("scgs", this.formInline[s].scgs);
          datas.append("sccc", this.formInline[s].sccc);
          datas.append("wjgs", this.formInline[s].wjgs);
          datas.append("sort", this.formInline[s].sort);
          await updmaterial(datas).then((res) => {});
          if (!set.includes(this.formInline[s].id)) {
            set.push(this.formInline[s].id);
          }
        }
      }
      for (let l = 0; l < this.formInline.length; l++) {
        if (
          this.formInline[l].sort === "" ||
          this.formInline[l].sort === null ||
          this.formInline[l].scmc === "" ||
          this.formInline[l].scmc === null
        ) {
          isss++;
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
      }
      if (isss === 0) {
        var data = new FormData();
        data.append("ids", set);
        data.append("status", "审批中");
        await updmaterialsp(data).then((res) => {
          console.log(res);
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: "上传成功",
              type: "success",
            });
            this.selmaterialis();
          }
        });
      }
    },
    // 跳转
    jump(item) {
      // this.$router.push("/materialdetailspage");
      // this.$store.commit("sucaixingqi", item.id);
    },
    // 文件保存
    submitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }

            this.selmaterialis();
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件保存
    sssubmitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            this.Fileuploadsss(iten);
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    async Fileuploadsss(item) {
      if (item.scmc) {
        if (item.sort) {
          var data = new FormData();
          data.append("ids", item.id);
          data.append("status", "已保存");
          await updmaterialsp(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.selmaterialis();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件上传
    async Fileupload(item) {
      console.log(item);
      var data = new FormData();
      data.append("phone", this.$store.state.user.phone);
      data.append("name", item.name);
      data.append("content", item.content);
      data.append("sort", item.sort);
      data.append("status", "待审核");
      data.append("cause", "");
      data.append("id", item.id);
      updknow(data).then((res) => {
        if (res.code == "OK") {
          var data1 = new FormData();
          data1.append("tid", item.tid);
          data1.append("phone", item.phone);
          data1.append("status", "已提交");
          updatetaskuser(data1).then((res) => {
            console.log(res);
          });
          this.selmaterialis();
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: "提交失败",
            type: "error",
          });
        }
      });
    },
    // // 全部删除
    // delmatess() {
    //   const set = []; // set 自带去重
    //   for (let s = 0; s < this.formInline.length; s++) {
    //     if (!set.includes(this.formInline[s].id)) {
    //       set.push(this.formInline[s].id);
    //     }
    //   }
    //   console.log(set);
    //   var data = new FormData();
    //   data.append("ids", set);
    //   delmaterial(data).then((res) => {
    //     if (res.code === "OK") {
    //       this.$message({
    //         showClose: true,
    //         message: res.msg,
    //         type: "success",
    //       });
    //       this.selmaterialis();
    //     }
    //   });
    // },
    // 删除
    delmaterial(item) {
      var data = new FormData();
      data.append("id", item.id);
      delknow(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("name", "知识科普");
      selsortMu(data).then((res) => {
        this.Majorcategories = res;
      });
    },
    // 列表
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("phone", this.$store.state.user.phone);
      if (this.name) {
        data.append("name", this.name);
      }
      if (this.value === "全部") {
      } else {
        data.append("status", this.value);
      }
      selknow(data).then((res) => {
        console.log(res);
        this.formInline = res.records;
        this.tepage.total = res.totalCount;
        // for (let i = 0; i < this.formInline.length; i++) {
        //   var a = this.formInline[i].statustime.split(" ");
        //   this.formInline[i].statustime = a[0];
        // }
      });
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.Materialtoupload {
  .box {
    min-height: 725px;
    .tbox-top {
      display: flex;
      // margin-top: 29px;
      height: 50px;

      .scsc {
        text-align: left;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }

      h2 {
        line-height: 40px;
        //   margin-right: 16px;
      }

      .el-select {
        line-height: 40px;
        width: 100px;

        ::v-deep .el-input__inner {
          border: 1px solid #5ccbff;
          height: 30px;
        }
      }

      .el-menu-demo {
        padding: 0;
        height: 30px;
        width: 40px;
        margin-left: 30px;
        line-height: 40px;
        border: 0px;
        display: flex;

        .el-menu-item {
          margin-left: 20px;
          padding: 0 5px;

          height: 30px;
          line-height: 24px;
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #4CCAFF;
        }

        ::v-deep.is-active {
          border-bottom: 2px solid #4ccaff;
        }
      }
    }

    .scscxsk {
      cursor: pointer;
      display: flex;
      margin-bottom: 10px;
    }

    .wzts {
      cursor: pointer;
      text-align: left;
      width: 770px;
      height: 151px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      display: flex;
      margin-bottom: 10px;

      video {
        width: 268px;
        height: 151px;

        opacity: 0.9;
        border-radius: 6px;
        line-height: 151px;
      }

      img {
        width: 268px;
        height: 151px;
        opacity: 0.8;
        border-radius: 6px;
      }

      .certer {
        padding: 0 20px;
      }
    }
  }
}

.searchbox {
  line-height: 40px;

  width: 255px;

  ::v-deep .el-input__inner {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-top-right-radius: 15px;
    // border-bottom-right-radius: 15px;
  }

  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;

    .el-button {
      position: relative;
      left: -10px;
      top: -1px;
      padding: 0px;
      width: 70px;
      height: 30px;
      background: #4ccaff;
      border: 1px solid #ededed;
      border-radius: 15px;
      color: #fff;
    }
  }
}

.deleta {
  line-height: 20px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fb4747;
  cursor: pointer;
}

.scscxsk {
  text-align: left;
  width: 770px;
  height: 151px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  transition: all 0.2s;

  video {
    width: 268px;
    height: 151px;

    opacity: 0.9;
    border-radius: 6px;
    line-height: 151px;
  }

  img {
    width: 268px;
    height: 151px;
    opacity: 0.8;
    border-radius: 6px;
  }

  .certer {
    padding: 0 20px;
  }
}

.scscxsk:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}

.right-bottom {
  display: flex;
  flex-direction: column;
  width: 76px;
  padding-right: 20px;

  button {
    margin: 0px;
    padding: 0;
    width: 76px;
    height: 28px;
    border-radius: 6px;
    border: 0;
  }

  .lasez {
    background: #4ccaff;
  }

  .lasez:hover {
    background: #4ccaffc9;
  }

  .sch:hover {
    background: #f56c6cc7;
  }
}

ul {
  padding-bottom: 50px;
}

.boytrtr {
  text-align: center;

  .el-button {
    padding: 0;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    border: 0px;
  }
}

.el-button:hover {
  background: #4ccaffc9;
}

.demo-form-s {
  width: 403px;
  margin-left: 16px;
  margin-right: 8px;
  margin-top: 18px;

  .el-form-item {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1818;
    // line-height: 44px;
  }
}

.smis {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  // line-height: 44px;
}

ul {
  min-height: 700px;
}

.paging {
  margin-bottom: 70px;
}

.sadda {
  margin: 20% 0px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: center;
}

.saddsa {
  // 通过

  color: #00c92f;
}

.saddsa1 {
  // 审批

  color: #4ccaff;
}

.saddsa2 {
  // 保存

  color: #666666;
}

.saddsa3 {
  // 驳回

  color: #fb4747;
}

.ssssc {
  line-height: 20px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
  margin-left: 450px;
  margin-right: 30px;
}

.el-button:hover {
  background: #4ccaffc9;
}

.el-pagination {
  ::v-deep button {
    padding: 0 5px;
  }
}

.dialogbhuyuan {
  text-align: left;

  p {
    padding-left: 20px;
  }
}

.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}

img {
  object-fit: contain;
}

.Materiaupload {
  position: fixed;
  top: 15.6rem;
  right: 11.2rem;

  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
  }
}

.altk {
  width: 48px;
  height: 48px;
  background: #4ccaff;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 8px;

  .iconfont {
    font-size: 28px;
    color: #fff;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Materialtoupload {
    .box {
      min-height: 725px;
      .tbox-top {
        span {
          display: block;
          width: 50px;
          z-index: 1;
        }
      }

      .scscxsk {
        cursor: pointer;
        display: block;
        margin-bottom: 10px;
      }

      .wzts {
        cursor: pointer;
        text-align: left;
        width: 90vw;
        height: 420px;
        display: block;
        video {
          width: 80vw;
          margin-left: 5vw;
          margin-top: 10px !important;
        }

        img {
          width: 80vw;
          margin-left: 5vw;
          margin-top: 10px !important;
        }

        .certer {
          padding: 0 20px;
        }
      }
    }
  }

  .searchbox {
    line-height: 40px;

    width: 255px;

    ::v-deep .el-input__inner {
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      // border-top-right-radius: 15px;
      // border-bottom-right-radius: 15px;
    }

    ::v-deep .el-input-group__append {
      margin-left: 100px;
      // line-height: 30px;
      border: 0px;
      background: #fff;

      .el-button {
        position: relative;
        left: -10px;
        top: -1px;
        padding: 0px;
        width: 70px;
        height: 30px;
        background: #4ccaff;
        border: 1px solid #ededed;
        border-radius: 15px;
        color: #fff;
      }
    }
  }

  .deleta {
    line-height: 20px;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fb4747;
    cursor: pointer;
  }

  .scscxsk {
    text-align: left;
    width: 90vw;
    height: 420px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
    border-radius: 6px;
    transition: all 0.2s;

    video {
      width: 80vw;
      margin-left: 5vw;
      margin-top: 10px !important;
    }

    img {
      width: 80vw;
      margin-left: 5vw;
      margin-top: 10px !important;
    }

    .certer {
      padding: 0 20px;
    }
  }

  .scscxsk:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }

  .right-bottom {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 80vw;
    padding-left: 10px;

    button {
      margin: 2px;
    }

    .lasez {
      background: #4ccaff;
    }

    .lasez:hover {
      background: #4ccaffc9;
    }

    .sch:hover {
      background: #f56c6cc7;
    }
  }

  ul {
    padding-bottom: 50px;
  }

  .boytrtr {
    text-align: center;

    .el-button {
      padding: 0;
      width: 99px;
      height: 28px;
      background: #4ccaff;
      border-radius: 6px;
      border: 0px;
    }
  }

  .el-button:hover {
    background: #4ccaffc9;
  }

  .demo-form-s {
    width: 80vw;
    margin-left: 16px;
    margin-right: 8px;
    margin-top: 18px;

    .el-form-item {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ff1818;
      // line-height: 44px;
    }
  }

  .smis {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    // line-height: 44px;
  }

  ul {
    min-height: 700px;
  }

  .paging {
    margin-bottom: 70px;
  }

  .sadda {
    margin: 20px 5px;
  }

  .saddsa {
    // 通过
    color: #00c92f;
  }

  .saddsa1 {
    // 审批

    color: #4ccaff;
  }

  .saddsa2 {
    // 保存

    color: #666666;
  }

  .saddsa3 {
    // 驳回

    color: #fb4747;
  }

  .ssssc {
    margin-left: 50px;
  }

  .el-button:hover {
    background: #4ccaffc9;
  }

  .el-pagination {
    ::v-deep button {
      padding: 0 5px;
    }
  }

  .dialogbhuyuan {
    text-align: left;

    p {
      padding-left: 20px;
    }
  }

  .el-pagination {
    ::v-deep span {
      padding: 0 10px;
    }
  }

  img {
    object-fit: contain;
  }

  .Materiaupload {
    position: fixed;
    top: 15.6rem;
    right: 11.2rem;

    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4ccaff;
    }
  }

  .altk {
    width: 48px;
    height: 48px;
    background: #4ccaff;
    border-radius: 6px;
    text-align: center;
    line-height: 48px;
    margin-bottom: 8px;

    .iconfont {
      font-size: 28px;
      color: #fff;
    }
  }
}
</style>

</style>
